import Enum from "./Enum";

export default Enum.create( {
	PRIVATE: "private",
	SHARED: "shared",
} );
